export { default } from './MessengerService';



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/messenger/services/MessengerService/index.js